import {cn} from 'platform/shared-tw';

import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

interface BatteryProps {
  variant?: DiagramVariant;
  onClick?: () => void;
}

export function Battery(props: BatteryProps) {
  return (
    <svg
      width="105"
      height="48"
      viewBox="0 0 105 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="absolute [pointer-events:none] cursor-pointer group"
      style={{bottom: 104, left: 51}}
      onClick={props.onClick}
    >
      <path
        d="M91 47C91 47 95 47 95 43V15H102C104 15 104 13 104 13V9C104 8.99564 103.998 7 102 7H95V5C95 5 95 1 91 1H31C27 1 27 5 27 5V7H20C18 7 18 9 18 9H13C5 9 5 18 5 18V25.3428C2.66984 26.1666 1 28.3877 1 31C1 34.3137 3.68629 37 7 37C10.3137 37 13 34.3137 13 31C13 28.3877 11.3302 26.1666 9 25.3428V19.001C9 19.001 9 13 14 13H18C18 13 18 15 20 15H27V43C27 43 27 47 31 47H91Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M95 15V43C95 47 91 47 91 47H31C27 47 27 43 27 43L27 15M95 7V5C95 5 95 1 91 1H31C27 1 27 5 27 5V7"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M86 9C86 9 86 7 88 7L102 7C104 7 104 9.00001 104 9.00001V13C104 13 104 15 102 15L88 15C86 15 86 13 86 13V9Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M18 9C18 9 18 7 20 7H34C36 7 36 9.00001 36 9.00001V13C36 13 36 15 34 15L20 15C18 15 18 13 18 13V9Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <circle
        cx="7"
        cy="31"
        r="6"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <circle
        cx="7"
        cy="31"
        r="2"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M9 25V19.0007C9 19.0007 9 13 14 13H18"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M5 25L5 18C5 18 5 9 13 9C21 9 18 9 18 9"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M67.823 24.5601L61.8118 33.5577C61.2608 34.3815 60.0138 33.9784 60.0138 32.9753V27.045H54.9886C54.1926 27.045 53.7236 26.1186 54.1776 25.4399L60.1888 16.4423C60.7398 15.6185 61.9868 16.0216 61.9868 17.0247V22.955H67.012C67.807 22.955 68.276 23.8814 67.823 24.5601Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
